import * as core from '../../../../../../../core'
import * as changeImpactYesNoNa from '../change-impact-yes-no-na'

export const RESOURCE = {
  payload: {
    description: 'Yes',
    enumId: core.dms.models.Enum.Id.from({
      partialId: changeImpactYesNoNa.RESOURCE.payload.partialId,
    }),
    id: 'Yes',
    name: 'Yes',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
